const form = `
  <div class="formio-core-questionnaire">
    {{ wizardHeader }}
    <div class="wizard-content">
      <div class="wizard-page" ref="{{ wizardKey }}">
        {{ components }}
      </div>
    </div>
      {{ wizardNav }}
    </div>
  </div>
`;

export default form;
